module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-layout/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"GameRally独立游戏创作市集 | 机核","short_name":"GameRally独立游戏创作市集","start_url":"/","background_color":"#202020","theme_color":"#f0f0f0","display":"minimal-ui","icon":"src/images/share-logo.jpg","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"0e4ab129e1a7207daba94b76c203d477"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
